module.exports = __webpack_public_path__ + "static/media/connect_4.81e98817.jpg";